module.exports = __webpack_public_path__ + "img/click_explore_UK.1965402d.svg";